import { useMemo } from 'react';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

import useFetch from 'hooks/useFetch';
import { fileUrl } from 'lib/gitlab';
import { LazyMarkdown } from 'routing/LazyMarkdown';

type Props = {
  document: string;
  skipHtml?: boolean;
  escapeHtml?: boolean;
};

const TextDocument = ({ document, skipHtml, escapeHtml = true }: Props) => {
  const data = useFetch(fileUrl(document));

  const rehypePlugins = useMemo(() => {
    return [
      remarkGfm,
      // If we accept html in input, we need rehypeRaw
      escapeHtml ? null : rehypeRaw,
    ].filter(Boolean);
  }, [escapeHtml]);

  return (
    <LazyMarkdown
      data={data}
      skipHtml={skipHtml}
      rehypePlugins={rehypePlugins}
    />
  );
};

export default TextDocument;
